// This file was automatically generated from render.header.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.header');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.header.patientOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ptDemoContainer"><p class="emphasis el8ItemDescription">For: ');
  el8.template.ptdata.patients.displayName(opt_data, output);
  output.append('</p><p class="el8ItemDescription">(', soy.$$escapeHtml(opt_data.sex), ') D.O.B.: ', soy.$$escapeHtml(opt_data.dob), '</p>', (opt_data.address) ? '<p class="el8ItemDescription">' + soy.$$escapeHtml(opt_data.address) + '</p>' : '', (opt_data.cityStateZip) ? '<p class="el8ItemDescription">' + soy.$$escapeHtml(opt_data.cityStateZip) + '</p>' : '', (opt_data.phone1 || opt_data.phone2) ? '<p>Phone: ' + soy.$$escapeHtml(opt_data.phone1 || opt_data.phone2) + '</p>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
